import React, { ReactElement } from 'react';
import { UrlMatcher, detectRichText } from '@kyruus/rich-text/Renderer';
import { ProviderLogos } from '@kyruus/provider-components';
import {
  PMCLogo,
  PMCLogoSections,
  ProviderMatchProviderV9
} from '@kyruus/types';
import {
  AboutContentContainer,
  AboutContentTitle,
  AboutContentText,
  AboutContentLogoContentContainer,
  AboutContentTextContainer,
  AboutContentLogosContainer
} from './styles';

interface AboutContentProps {
  content: string;
  dataTestId: string;
  logoConfigs: PMCLogo[];
  fieldType?: string;
  title?: string;
  provider: ProviderMatchProviderV9;
  autolink?: {
    enabled?: boolean;
    customTLDs?: string[];
  };
}

const AboutContent = ({
  content,
  logoConfigs,
  dataTestId,
  fieldType,
  title,
  provider,
  autolink: { enabled = true, customTLDs = [] } = {}
}: AboutContentProps): ReactElement => {
  const titleContent = title ? (
    <AboutContentTitle itemProp="name" data-testid={`${dataTestId}-title`}>
      {title}
    </AboutContentTitle>
  ) : null;
  const richText = fieldType === 'rich_text' || detectRichText(content);
  const textContent = (
    <div itemProp="description">
      <AboutContentText
        content={content}
        data-testid={`${dataTestId}-content`}
        disableDefaultMatchers={true}
        matchers={enabled ? [new UrlMatcher('url', { customTLDs })] : []}
        newWindow={true}
        tagName={richText ? 'div' : 'p'}
      />
    </div>
  );

  return (
    <AboutContentContainer
      data-testid={dataTestId}
      itemScope={true}
      itemType="https://schema.org/PropertyValue"
      itemProp="additionalProperty"
    >
      {logoConfigs.length > 0 ? (
        <AboutContentLogoContentContainer>
          {titleContent}
          <AboutContentTextContainer>{textContent}</AboutContentTextContainer>
          <AboutContentLogosContainer
            data-testid={`${dataTestId}-logos-container`}
          >
            <ProviderLogos
              logoConfigs={logoConfigs}
              provider={provider}
              logoSection={PMCLogoSections.PROFILE}
              isVertical={false}
              itemProp="image"
            />
          </AboutContentLogosContainer>
        </AboutContentLogoContentContainer>
      ) : (
        <>
          {titleContent}
          {textContent}
        </>
      )}
    </AboutContentContainer>
  );
};

export default AboutContent;
